import DigidomCgv from './DigidomCgv';

export default DigidomCgv;
